import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-device-router',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './device-router.component.html',
  styleUrl: './device-router.component.scss',
})
export class DeviceRouterComponent {}
